
  /**
   * @license
   * author: epignosis front-end team
   * @epignosis_llc/gnosis.js v6.0.0
   * Released under the MIT license.
   */

import * as React from 'react';

var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function SvgDanger(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 1740",
    fill: "none",
    d: "M0 0h32v32H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2644",
    d: "M18.043 16.25h2.872a.571.571 0 00.58-.612 5.789 5.789 0 00-2.162-3.913.588.588 0 00-.872.137l-1.515 2.423a2.324 2.324 0 011.097 1.965zm-3.551 1.965l-1.519 2.43a.574.574 0 00.207.816 5.689 5.689 0 002.535.6 5.736 5.736 0 002.535-.6.569.569 0 00.207-.816l-1.518-2.43a2.3 2.3 0 01-1.227.359 2.3 2.3 0 01-1.22-.359zm-3.966-1.965H13.4a2.316 2.316 0 011.1-1.965l-1.52-2.422a.588.588 0 00-.872-.137 5.8 5.8 0 00-2.162 3.912.571.571 0 00.58.612zm5.193 1.16a1.161 1.161 0 001.16-1.16 1.161 1.161 0 00-1.16-1.16 1.161 1.161 0 00-1.16 1.16 1.161 1.161 0 001.16 1.16zm0 7.559a8.717 8.717 0 008.719-8.719 8.717 8.717 0 00-8.719-8.719A8.717 8.717 0 007 16.25a8.717 8.717 0 008.719 8.719zm0-15.75a7.038 7.038 0 017.031 7.031 7.038 7.038 0 01-7.031 7.031 7.038 7.038 0 01-7.031-7.031 7.038 7.038 0 017.031-7.031z",
    fill: "currentColor"
  })));
}

export { SvgDanger as default };
//# sourceMappingURL=danger.svg.js.map
